import type { CityConfig } from "../city-template/types";

export const broomfieldConfig: CityConfig = {
  city: "Broomfield",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "broomfield",
  route: "/broomfield",
  title: "Emergency Passport Broomfield, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Broomfield, Colorado — as fast as 24 hours. Same-day courier processing for Broomfield, Westminster, Thornton, Lafayette, and all Flatirons corridor travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Broomfield, CO",
  heroSubtitle: "Business trip to Europe with a last-minute passport issue? Family vacation booked and you just noticed your passport expired? We help Broomfield residents — from Interlocken professionals to Broadlands families to FlatIron Crossing shoppers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Broomfield%20Colorado%20view%20of%20the%20Flatirons%20mountain%20backdrop%20from%20an%20elevated%20residential%20neighborhood%2C%20modern%20suburban%20office%20park%20at%20Interlocken%20business%20district%20with%20glass%20buildings%20against%20mountain%20landscape%2C%20green%20open%20space%20trails%20with%20prairie%20grasslands%20and%20distant%20snow%20capped%20peaks%2C%20sunny%20clear%20day%20with%20deep%20blue%20Colorado%20sky%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20composition%20with%20rich%20color%20contrast&width=1800&height=700&seq=broomfield-hero-001&orientation=landscape",
  heroImageAlt: "Broomfield Colorado with Flatirons mountain views and Interlocken business district",
  geoPosition: "39.9205;-105.0867",
  geoPlacename: "Broomfield, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 25 miles southeast via US-36 and I-25 — about 35 minutes",
  },
  nearbyCitiesZips: [
    { name: "Broomfield", zips: "80020, 80021, 80023" },
    { name: "Westminster", zips: "80021, 80023, 80030" },
    { name: "Thornton", zips: "80023, 80229, 80260" },
    { name: "Lafayette", zips: "80026" },
    { name: "Louisville", zips: "80027" },
    { name: "Erie", zips: "80516" },
    { name: "Superior", zips: "80027" },
    { name: "Northglenn", zips: "80234, 80260" },
    { name: "Arvada", zips: "80004, 80005, 80007" },
    { name: "Federal Heights", zips: "80260" },
    { name: "Boulder", zips: "80301, 80302, 80303, 80304" },
    { name: "Longmont", zips: "80501, 80503, 80504" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Broomfield international travel — business or leisure" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive to Aurora for the Colorado Passport Agency" },
    { icon: "ri-flight-takeoff-line", title: "DEN Airport Proximity", desc: "Just 35 minutes from Denver International — same-day courier coordination for last-minute flights" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Broomfield, Westminster, or FlatIron" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Boulder, CO", route: "/boulder" },
    { name: "Fast passport renewal in Westminster area", route: "/broomfield" },
    { name: "Urgent passport services for Thornton", route: "/broomfield" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Interlocken area", route: "/broomfield" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Broomfield remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Broomfield's central location at the intersection of US-36 and I-25 gives us fast access to the Colorado Passport Agency — but you never need to make the drive yourself.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Broomfield County and the Flatirons corridor including Westminster, Thornton, Lafayette, and Louisville",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Broomfield and the northern metro corridor. From the Interlocken business district to FlatIron Crossing, from Broadlands to Anthem — we serve every neighborhood in Broomfield and the surrounding communities.",
  nearbyCitiesIntro: "We serve Broomfield and all nearby northern metro communities including Westminster, Thornton, Lafayette, Louisville, Erie, Superior, Northglenn, and Arvada. We also serve Boulder, Longmont, and the entire Flatirons corridor.",
  howItWorksIntro: "Most Broomfield travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 25 miles south to the Colorado Passport Agency in Aurora.",
  mistakesIntro: "Broomfield is a growing tech and business hub with frequent international business travel and family vacations. Here are the most common passport mistakes we see from Broomfield-area travelers.",
  testimonialsIntro: "Broomfield travelers — from Interlocken business professionals to Broadlands families to FlatIron shoppers — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Broomfield, CO? Here are the most common ones we hear from northern metro travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death, Marriage)", href: "https://cdphe.colorado.gov/certificates-and-records" },
    { label: "Broomfield Clerk & Recorder", href: "https://www.broomfield.org/151/Clerk-Recorder" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Broomfield", "Perfect for international business trips and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (35 minutes each way)", "Limited appointments — book 2 weeks ahead"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Broomfield travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without the drive to Aurora.",
      bullets: ["24–48 hour turnaround available", "DEN departure support", "International business travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Broomfield adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Broomfield address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Broomfield residents and families — including new citizens and young children.",
      bullets: ["Acceptance facility scheduling in Broomfield or Westminster", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Broomfield residents who lost their passport before international travel — business or vacation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Broomfield and northern metro families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Broomfield and Broomfield County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Broomfield CO", description: "Urgent passport processing for Broomfield Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Broomfield CO", description: "Fast passport renewal for Broomfield Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Broomfield CO", description: "New passport application services for Broomfield Colorado residents applying for their first passport." },
    { name: "Child Passport Broomfield CO", description: "Minor passport services for Broomfield Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "David K.",
      location: "Broomfield, CO — Interlocken",
      rating: 5,
      text: "Business trip to London with 5 days notice. Fast Passport Center handled my renewal in 2 days. Shipped from the UPS Store on 120th and everything was seamless. Unbelievable speed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jennifer M.",
      location: "Broomfield, CO — Broadlands",
      rating: 5,
      text: "Family trip to Cancun over spring break. Three passports — one renewal and two first-time for the kids. All done in 5 days. The courier service is incredible for busy families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Robert T.",
      location: "Westminster, CO",
      rating: 5,
      text: "Last-minute business trip to Tokyo — realized my passport had only 4 months of validity. Fast Passport Center got me a new one in 3 days. Saved the entire trip.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa R.",
      location: "Lafayette, CO",
      rating: 5,
      text: "Lost my passport before a European river cruise. They replaced it in 48 hours. The daily updates throughout the process kept me calm. Absolutely recommend.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "brm-1",
      name: "Broomfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "280 E 1st Ave",
      city: "Broomfield",
      state: "CO",
      zip: "80020",
      phone: "(303) 466-0065",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Downtown Broomfield, near 1st Avenue and Main Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Broomfield acceptance facility. Appointments recommended — walk-ins available but limited. Good parking.",
      icon: "ri-mail-line",
    },
    {
      id: "brm-2",
      name: "Westminster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3030 W 72nd Ave",
      city: "Westminster",
      state: "CO",
      zip: "80030",
      phone: "(303) 426-2516",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Westminster, approximately 5 miles south of Broomfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with extended hours. Good alternative to Broomfield for easier scheduling.",
      icon: "ri-mail-line",
    },
    {
      id: "brm-3",
      name: "Thornton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11740 Washington St",
      city: "Thornton",
      state: "CO",
      zip: "80233",
      phone: "(303) 451-4998",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Thornton, approximately 8 miles east of Broomfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Thornton and northern metro residents. Good parking and typically shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "brm-4",
      name: "Lafayette Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W South Boulder Rd",
      city: "Lafayette",
      state: "CO",
      zip: "80026",
      phone: "(303) 665-7558",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lafayette, approximately 8 miles north of Broomfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Lafayette and Louisville residents. Smaller facility — call ahead for availability.",
      icon: "ri-mail-line",
    },
    {
      id: "brm-5",
      name: "Boulder Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1905 15th St",
      city: "Boulder",
      state: "CO",
      zip: "80302",
      phone: "(303) 938-1020",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Boulder, approximately 12 miles northwest of Broomfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in the area. Full service with extended hours. Good for Boulder County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35-min drive to Aurora on I-25", fpc: "No — ship from Broomfield" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Business Travel Ready", agency: "Unpredictable timing", fpc: "Guaranteed turnaround for business schedules" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Broomfield's international business travelers often book trips weeks in advance but forget to check their passport. Routine processing takes 8–11 weeks. Start expedited service at least 3 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services sometimes produce photos with incorrect sizing or backgrounds. Passport photos must be exactly 2×2 inches on a white background — no exceptions, no shadows.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early",
      description: "Broomfield and Westminster post office appointments fill during peak travel seasons — summer (June–August) and holiday season (November–December). Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries in Europe and Asia require 6 months of passport validity beyond your stay. Broomfield business travelers heading to London, Frankfurt, or Tokyo often discover this too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Both Parents for Child Passports",
      description: "U.S. law requires both parents to appear in person for a child's first passport (under 16). Many Broomfield families show up with only one parent and get turned away.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Assuming DEN Is Only for Domestic Flights",
      description: "DEN has extensive international connections, but many travelers don't realize they need a passport for connections through Canadian hubs like Toronto or Vancouver.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Broomfield or the Flatirons corridor." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Broomfield, Westminster, or Boulder." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Flatirons corridor documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-25 or US-36 drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Broomfield address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Broomfield, CO?", a: "Fast Passport Center offers emergency passport processing in Broomfield, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 25-mile drive to the Colorado Passport Agency in Aurora." },
    { q: "Does Broomfield have its own passport agency?", a: "No — Broomfield does not have a regional passport agency. The nearest is the Colorado Passport Agency (25 miles southeast via US-36 and I-25). Fast Passport Center's courier service means you never need to deal with I-25 traffic." },
    { q: "How far is Broomfield from Denver International Airport (DEN)?", a: "Denver International Airport is approximately 35 minutes southeast of Broomfield via E-470 or I-25. DEN offers extensive international flights to Europe, Asia, Mexico, and Canada — perfect for Broomfield's international business community." },
    { q: "What if I live in Westminster, Thornton, or Lafayette?", a: "Absolutely. Fast Passport Center serves all of Broomfield County and the surrounding northern metro area including Westminster, Thornton, Lafayette, Louisville, Erie, Superior, and Northglenn. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "Can you help with passports for Interlocken business travelers?", a: "Yes. Fast Passport Center has extensive experience with Broomfield's business community — from Interlocken tech companies to FlatIron area executives. We understand corporate travel schedules and can coordinate expedited services to match tight timelines." },
    { q: "How much does an expedited passport cost in Broomfield, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Broomfield?", a: "Walgreens (5000 W 120th Ave and 4100 W 144th Ave) offers passport photo services. UPS Store locations on 120th Ave and in FlatIron Crossing also provide photos. FedEx Office in Westminster is another option. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the entire Flatirons corridor?", a: "Yes. Fast Passport Center serves all of the Flatirons corridor including Broomfield, Boulder, Louisville, Lafayette, Erie, and Superior. Our registered courier network covers the entire northern Denver metro area." },
  ],
  photoLocations: [
    { name: "Walgreens — 120th Ave Broomfield", address: "5000 W 120th Ave, Broomfield, CO 80020", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "Walgreens — 144th Ave Broomfield", address: "4100 W 144th Ave, Broomfield, CO 80023", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Broomfield", address: "1 Garden Center, Broomfield, CO 80020", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Westminster", address: "10359 Federal Blvd, Westminster, CO 80260", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Westminster (Adams County)", address: "8452 Federal Blvd, Westminster, CO 80031", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Broomfield and northern metro residents. REAL ID and driver's license renewals. Approximately 5 miles from Broomfield.", featured: true },
    { name: "DMV — Boulder (Boulder County)", address: "2850 Iris Ave, Boulder, CO 80304", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for Boulder County residents. REAL ID processing available. Approximately 12 miles from Broomfield.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "32 miles from Broomfield via E-470",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. 35-minute drive from Broomfield in normal traffic.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "BJC",
      name: "Rocky Mountain Metropolitan Airport",
      distance: "10 miles from Broomfield via US-36",
      address: "11755 Airport Way, Broomfield, CO 80021",
      note: "General aviation and corporate airport serving Broomfield and the northern metro. Private jet and charter services available. No commercial passenger flights.",
      flightUrl: "https://www.flyrmma.com/",
      flightLabel: "BJC Airport Info",
      featured: false,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "85 miles from Broomfield via I-25 south",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Alternative regional airport with domestic connections. About 1.5 hours south of Broomfield.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: false,
    },
  ],
};